export default "__VITE_ASSET__cgj9bDNt__"